import React from "react";
import { Link } from "react-router-dom";
import { getDatabase } from "firebase/database";
import { collection, getDocs, orderBy, query, doc, deleteDoc } from "firebase/firestore";
import NavBar from "../Components/NavBar";
import Button from '@mui/material/Button';

function DeletePost() {
    //States for the firestore documents
    const [items, setItems] = React.useState([]);
    const [ids, setIds] = React.useState([]);

    React.useEffect(() => {
		const fetchItems = async () => {
			const q = query(collection(getDatabase, "Posts"), orderBy("Time", "desc"));
			const querySnapshot = await getDocs(q);
			setItems(querySnapshot.docs.map((doc) => doc.data()));
            setIds(querySnapshot.docs.map((doc) => doc.id));
		};
		fetchItems();
	}, []);

    const handleDelete = async (index) => {
        console.log("test")
        var id = ids[index];
        try {
            await deleteDoc(doc(getDatabase, "Posts", id));
            console.log("Document successfully deleted!");
            window.location.href = `/`;
        } catch (error) {
            console.error("Error removing document: ", error);
        }
    }

    return (
        <>
            <NavBar/>
            <div className="editBox">
                <ul >
                    {items.map((item, index) => (
                        <li key={index}>
                            <Link to={`/post/${ids[index]}`}>
                                
                                {item.Title} -------- {item.Time.toDate().toISOString().split('T')[0]}
                                
                            </Link>
                            <Button className="delbutton" variant="outlined" onClick = {function(){handleDelete(index)}}>Delete</Button>
                        </li>
                    ))}
                </ul>
            </div>
        </>
    )
}

export default DeletePost;
